import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight, Clock, MessageCircleOff, BookX, Timer, CheckCircle2 } from 'lucide-react';
import { Button } from '../../components/ui/Button';
import { DjayToetsAvatar } from '../../mascot';
import { DOMAIN_META } from '../utils/assessmentDomainConfig';
import type { AssessmentDomainId } from '../types';
import { useEscapeKey } from '../../app/hooks/useEscapeKey';
interface AssessmentIntroScreenProps {
  domainId: AssessmentDomainId;
  questionCount: number;
  onStart: () => void;
  onCancel: () => void;
}
export function AssessmentIntroScreen({
  domainId,
  questionCount,
  onStart,
  onCancel
}: AssessmentIntroScreenProps) {
  const meta = DOMAIN_META[domainId];
  const minutesPerQuestion = domainId === 'rekenen' ? 1.4 : 1.2;
  const estimatedMinutes = Math.round(questionCount * minutesPerQuestion);
  return <div className="min-h-screen bg-slate-50 flex items-center justify-center p-4 font-sans text-slate-800" data-id="element-736" data-mp="1oypjtk55a2fy">
      <motion.div initial={{
      opacity: 0,
      y: 20
    }} animate={{
      opacity: 1,
      y: 0
    }} transition={{
      duration: 0.5
    }} className="w-full max-w-md text-center" data-id="element-737" data-mp="2a69hpeodmtb">
        
        <motion.div initial={{
        scale: 0.8,
        opacity: 0
      }} animate={{
        scale: 1,
        opacity: 1
      }} transition={{
        delay: 0.15,
        type: 'spring',
        bounce: 0.4
      }} className="flex justify-center mb-6" data-id="element-738" data-mp="3pf5kxg0ta2cg">
          
          <DjayToetsAvatar domain={domainId} size="lg" animate data-id="element-739" data-mp="m09v625k2t8i" />
        </motion.div>

        <h1 className="text-3xl font-black text-slate-900 mb-2 tracking-tight" data-id="element-740" data-mp="pyz6zqay42q1">
          {meta.label}
        </h1>
        <p className="text-slate-500 text-sm font-medium mb-8" data-id="element-741" data-mp="c6jc5cs77b07">Toets</p>

        <div className="flex items-center justify-center gap-6 text-slate-600 font-medium mb-10" data-id="element-742" data-mp="h5vzdymzek3b">
          <div className="flex items-center" data-id="element-743" data-mp="14vgl2pairvga">
            <CheckCircle2 className="w-4 h-4 mr-2 text-slate-400" data-id="element-744" data-mp="19nhs9wstyvzg" />
            {questionCount} vragen
          </div>
          <div className="flex items-center" data-id="element-745" data-mp="1jk02dwkqxkmj">
            <Clock className="w-4 h-4 mr-2 text-slate-400" data-id="element-746" data-mp="1jhnn5r6dhod6" />~{estimatedMinutes}{' '}
            minuten
          </div>
        </div>

        <div className="space-y-4 mb-10 text-left inline-block" data-id="element-747" data-mp="19lajq1l0zw58">
          <div className="flex items-center gap-4" data-id="element-748" data-mp="19nnb15cobiuy">
            <MessageCircleOff className="w-5 h-5 text-slate-400 shrink-0" data-id="element-749" data-mp="14n8zhdbv5qs6" />
            <p className="text-slate-600 font-medium" data-id="element-750" data-mp="10km5p6vmtvsc">
              Geen feedback na elke vraag
            </p>
          </div>
          <div className="flex items-center gap-4" data-id="element-751" data-mp="vt4evbnbpbl3">
            <BookX className="w-5 h-5 text-slate-400 shrink-0" data-id="element-752" data-mp="vsb3fxdf5xwm" />
            <p className="text-slate-600 font-medium" data-id="element-753" data-mp="qvkojddcp8cs">
              Geen spiekbriefje of hulp
            </p>
          </div>
          <div className="flex items-center gap-4" data-id="element-754" data-mp="lu53vmf353ux">
            <Timer className="w-5 h-5 text-slate-400 shrink-0" data-id="element-755" data-mp="gvtvlg4fv1et" />
            <p className="text-slate-600 font-medium" data-id="element-756" data-mp="cvjp82cqi8zf">Neem rustig de tijd</p>
          </div>
        </div>

        <Button onClick={onStart} size="xl" fullWidth className="bg-orange-500 text-white hover:bg-orange-600 shadow-xl rounded-2xl text-fluid-lg font-bold mb-6" data-id="element-757" data-mp="2oiwwoyei94vc">
          
          <span className="mr-2" data-id="element-758" data-mp="2sm3263tsms0r">Ik ben er klaar voor</span>
          <ArrowRight className="w-5 h-5" strokeWidth={3} data-id="element-759" data-mp="2xkmoi5cau5tn" />
        </Button>

        <button onClick={onCancel} className="text-sm text-slate-400 hover:text-slate-600 font-medium transition-colors" data-id="element-760" data-mp="32io7kq9q6554">
          
          Annuleren en terug
        </button>
      </motion.div>
    </div>;
}